import {
  SET_INVENTORIES,
  SET_TOLERANCES,
  SET_CATEGORIES,
  SET_PRODUCTS,
  SET_BRANDS,
} from '../types/inventory'

const initState = {
  inventories: {},
  tolerances: {},
  categories: {},
  products: {},
  brands: {},
  lastModified: new Date().getTime(),
}

const inventoryReducer = (state = initState, action = {}) => {
  const { type, payload } = action

  switch (type) {
    case SET_INVENTORIES:
      return { ...state, inventories: payload, lastModified: new Date().getTime() }
    case SET_TOLERANCES:
      return { ...state, tolerances: payload.tolerances, lastModified: new Date().getTime() }
    case SET_CATEGORIES:
      return { ...state, categories: payload.categories, lastModified: new Date().getTime() }
    case SET_PRODUCTS:
      return { ...state, products: payload.products }
    case SET_BRANDS:
      return { ...state, brands: payload.brands }
    default:
      return state
  }
}

export default inventoryReducer



// WEBPACK FOOTER //
// ./src/reducers/inventory.js